import { FileMetaData } from "./FileToUpload";
import { ServiceRequestEquipmentItem } from "./ServiceRequestEquipmentItem";

export class ServiceRequest {
  poNumber: string;
  comments: string;
  vendor: string;
  fromContact: string;
  trackingNumber: string;
  serviceWorkType: string;
  customerEmail: string;
  phoneNumber: string;
  document: FileMetaData; // the content of the file is sent as form data separately
  shipTo: string;
  companyId: string;
  equipments: ServiceRequestEquipmentItem[];
  isShipmentRequested: boolean;
  shipment?: Shipment;

  commentsToShow?: string; // to show in Service Request after submit
}

export interface Shipment {
  description?: string;
  isDangerousGood: boolean;
  parcels: Parcel[];
  startDateTime: string;
  closeDateTime: string;
}

export interface Parcel {
  length: number;
  width: number;
  height: number;
  weight: number;
}

export const FormKeys: Record<string, string> = {
  trackingNumber: "trackingNumber",
  poNumber: "poNumber",
  phoneNumber: "phoneNumber",
  isShipmentRequested: "isShipmentRequested",
  parcelsAdditionalInfo: "parcelsAdditionalInfo",
  pickupDate: "pickupDate",
  businessStart: "businessStart",
  businessEnd: "businessEnd",
  totalParcels: "totalParcels",
  shippingParcels: "shippingParcels",
  weight: "weight",
  length: "length",
  width: "width",
  height: "height",
  parcelType: "parcelType",
  description: "description",
};
